import ValidatedInput from './ValidatedInput'
import ValidatedEmailInput from './ValidatedEmailInput'
import ValidatedPromoInput from './ValidatedPromoInput'
import ValidatedPasswordInput from './ValidatedPasswordInput'

export default ValidatedInput
export { ValidatedEmailInput, ValidatedPromoInput, ValidatedPasswordInput }
